import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Faturação automática',
  buttons: {
    add_subscription: 'Adicionar subscrição',
    suspend_company: 'Suspender restaurante',
    restore_company: 'Restaurar restaurante',
    edit_suspend: 'Editar informação de suspensão',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  modals: {
    suspend_company: {
      title: 'Tem a certeza que pretende suspender {{company}}?',
      description:
        'Isto irá cancelar todas as subscrições ativas, desativar encomendas em direto e notificar o proprietário do restaurante por email sobre o cancelamento. Por favor, selecione um motivo antes de confirmar.',
      suspense_reason: {
        label: 'Selecionar motivo de suspensão',
        placeholder: 'Escolha um motivo',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Encerramento ou Mudança de Proprietário',
          [SUSPENSE_REASON.LowRoi]: 'ROI Baixo',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Sensibilidade a Preços/Taxas',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Integrações em Falta/Lacunas no Produto',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Integração/Ativação Deficiente',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Insatisfação com o Suporte',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Mudança para Concorrente/Marketplace/DIY',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Deceção com Desempenho de Marketing',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Registo/Dados Incorretos',
        },
        validation: {
          required: 'Por favor, escolha um motivo',
        },
      },
      suspense_competitor: {
        label: 'Para que concorrente migraram?',
        placeholder: 'Por favor, escolha um concorrente',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Outro',
        },
        validation: {
          required: 'Por favor, escolha um concorrente',
        },
      },
      suspense_reason_notes: {
        label: 'Contexto adicional (opcional)',
        placeholder: 'Forneça detalhes adicionais',
      },
    },
    restore_company: {
      title: 'Tem a certeza que pretende restaurar {{company}}?',
      description: 'Ainda terá de criar a subscrição e ativar as encomendas em direto manualmente.',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar detalhes da subscrição',
    failed_to_suspend_company: 'Falha ao suspender o restaurante. Por favor, contacte o suporte técnico',
    failed_to_restore_company: 'Falha ao restaurar o restaurante. Por favor, contacte o suporte técnico',
  },
};
